import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetSellers = ({
  page = 1,
  limit = 10,
  sortColumn = "date_created",
  sortOrder = "asc",
  status = '',
  search = "",
  searchObject = {},
}) => {
  return useQuery({
    queryKey: ["sellers", page, limit, sortColumn, sortOrder, status, search, searchObject],
    queryFn: async () => {
      const response = await axios.get("/api/sellerprofile/bop", {
        params: {
          page,
          limit,
          sortColumn,
          sortOrder,
          status,
          search,
          ...(Object.keys(searchObject).length && { searchObject }),
        },
      });
      return response.data;
    },
    keepPreviousData: true,
    staleTime: 0, // Optional: always refetch
  });
};

export default useGetSellers;
